import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import RegistrationPage from './pages/RegistrationPage';
import ExperimentIntroPage from './pages/ExperimentIntroPage';
import EmotionListPage from './pages/EmotionListPage';
import TaskPage from './pages/TaskPage';
import ThankYouPage from './pages/ThankYouPage';
import TrainingIntroPage from './pages/TrainingIntroPage';
import TrainingTaskPage from './pages/TrainingTaskPage';
import TestSelectionPage from './pages/TestSelectionPage';
import TestCompletePage from './pages/TestCompletePage';
import AllTestsCompletePage from './pages/AllTestsCompletePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import DataProcessingPolicyPage from './pages/DataProcessingPolicyPage';
import './App.css';

function App() {
  const [userId, setUserId] = useState(() => localStorage.getItem('emotionSurveyUserId'));
  const [trainingCompleted, setTrainingCompleted] = useState(() =>
    localStorage.getItem('emotionSurveyTrainingCompleted') === 'true'
  );
  const handleLogin = (id) => {
    localStorage.setItem('emotionSurveyUserId', id);
    setUserId(id);
  };

  const handleLogout = () => {
    localStorage.removeItem('emotionSurveyUserId');
    localStorage.removeItem('emotionSurveyVideoQueue');
    localStorage.removeItem('emotionSurveyCurrentVideoIndex');
	localStorage.removeItem('emotionSurveyTrainingCompleted');
    localStorage.removeItem('emotionSurveyCurrentTaskVideo');
    localStorage.removeItem('emotionSurveyCurrentTaskNumber');
	localStorage.removeItem('emotionSurveyCurrentTestMode');
    localStorage.removeItem('emotionSurveySoundTestCompleted');
    localStorage.removeItem('emotionSurveySilentTestCompleted');
	localStorage.removeItem('trainingCurrentIndex');
    localStorage.removeItem('trainingIsVideoFinished');
    setUserId(null);
    setTrainingCompleted(false);
  };

  const getCurrentTestPath = () => {
    const currentVideo = localStorage.getItem('emotionSurveyCurrentTaskVideo');
    const currentMode = localStorage.getItem('emotionSurveyCurrentTestMode');
    const soundDone = localStorage.getItem('emotionSurveySoundTestCompleted') === 'true';
    const silentDone = localStorage.getItem('emotionSurveySilentTestCompleted') === 'true';
	const anyTestCompleted = soundDone || silentDone;

    if (currentVideo && currentMode) {
      return currentMode === 'silent' ? '/task-silent' : '/task-sound';
    }

    if (!currentMode && anyTestCompleted) {
      return '/all-tests-complete';
    }

    return '/test-selection';
  };
  
  const ProtectedRoute = ({ children }) => {
    if (!userId) {
      return <Navigate to="/" replace />;
    }
    return children;
  };
  
  return (
    <Router>
      <div className="app-container">
        <main>
          <Routes>
            <Route
              path="/"
              element={
                userId
                  ? trainingCompleted
                    ? <Navigate to={getCurrentTestPath()} />
                    : <Navigate to="/experiment-intro" />
                  : <RegistrationPage onRegister={handleLogin} />
              }
            />
			<Route
              path="/training-intro"
              element={
                <ProtectedRoute>
                  {trainingCompleted ? <Navigate to="/test-selection" /> : <TrainingIntroPage />}
                </ProtectedRoute>
              }
            />
            <Route
              path="/training-task"
              element={
                <ProtectedRoute>
                  {trainingCompleted ? <Navigate to="/test-selection" /> : <TrainingTaskPage setTrainingCompleted={setTrainingCompleted} />}
                </ProtectedRoute>
              }
            />
            <Route
              path="/experiment-intro"
              element={<ProtectedRoute><ExperimentIntroPage /></ProtectedRoute>}
            />
            <Route
              path="/emotion-list"
              element={<ProtectedRoute><EmotionListPage /></ProtectedRoute>}
            />
			<Route
              path="/test-selection"
              element={<ProtectedRoute><TestSelectionPage /></ProtectedRoute>}
            />
            <Route
              path="/task-sound"
              element={
                <ProtectedRoute>
                   <TaskPage currentUserId={userId} muted={false} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/task-silent"
              element={
                <ProtectedRoute>
                  <TaskPage currentUserId={userId} muted={true} />
                </ProtectedRoute>
              }
            />
             <Route
              path="/test-complete-sound"
              element={<ProtectedRoute><TestCompletePage mode="sound" /></ProtectedRoute>}
            />
            <Route
              path="/test-complete-silent"
              element={<ProtectedRoute><TestCompletePage mode="silent" /></ProtectedRoute>}
            />
            <Route
              path="/all-tests-complete"
              element={<AllTestsCompletePage handleLogout={handleLogout} />}
            />
                        <Route
              path="/thank-you"
              element={<ProtectedRoute><ThankYouPage handleLogout={handleLogout} /></ProtectedRoute>}
            />
			<Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/data-processing-policy" element={<DataProcessingPolicyPage />} />
            {/* При успешной регистрации будем перенаправлять на /experiment-intro */}
            <Route
              path="*"
              element={
                userId
                  ? trainingCompleted
                    ? <Navigate to={getCurrentTestPath()} />
                    : <Navigate to="/experiment-intro" />
                  : <Navigate to="/" />
              }
            />
          </Routes>
        </main>
        <footer className="app-footer">
		 {userId && (
            <div className="logout-button-container">
              <button onClick={handleLogout} className="app-header-button logout-button">
                Выйти и очистить сессию
              </button>
            </div>
          )}
          <p>&copy; {new Date().getFullYear()} Исследование эмоций</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;